<template>
  <v-dialog
      v-model="dialog"
      width="500"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-card max-width="100" v-bind="attrs" v-on="on">
        <v-img :src="'https://www.themoviedb.org/t/p/w600_and_h900_bestv2/' + record.poster"/>
      </v-card>
    </template>

    <v-card>
      <v-card-title>
        {{ record.original_title }}
      </v-card-title>

      <v-img max-height="150" :src="'https://www.themoviedb.org/t/p/original/' + record.backdrop"/>
      <v-card-text class="mt-5" style="white-space: nowrap;">
        <v-icon>
          mdi-calendar
        </v-icon>
        {{new Date(record.timestamp).toLocaleDateString()}}

        <v-icon class="ml-6">
          mdi-clock
        </v-icon>
        {{new Date(record.timestamp).toLocaleTimeString()}}
      </v-card-text>
      <v-card-text >
        {{ record.overview }}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
            color="#7400b8"
            text
            @click="toMovieDetails(record.tmdb_id)"
        >
          Más info
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            color="#7400b8"
            text
            @click="dialog = false"
        >
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ClickableMovieCard",
  props: ['record'],
  data: () => ({
    'dialog': false,
  }),
  methods: {
    toMovieDetails(tmdb_id) {
      window.open('https://www.themoviedb.org/movie/' + tmdb_id + '?language=es-MX')
    }
  }
}
</script>

<style scoped>

</style>
